import {
  checkErrors,
  getEmptyContent
} from '@com-delta-idp/mnx-skymiles-shared';
import { DisplayProperties } from '@com-delta-omnichannel/aura';
import { ErrorMessages } from '../models/error-messages.constants';

export type FullPageErrorState = Required<DisplayProperties>;

export const getFullPageError = (
  errors: (string | undefined)[]
): FullPageErrorState => {
  if (checkErrors(errors, ErrorMessages)) {
    return getEmptyContent<FullPageErrorState>(
      'full-page',
      ErrorMessages,
      true
    );
  }
  return getEmptyContent<FullPageErrorState>();
};
